import styled from 'styled-components/macro';

export const Wrapper = styled.div<{ isFullSize: boolean }>`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  width: ${(props) => (props.isFullSize ? '100%' : 'fit-content')};
  height: ${(props) => (props.isFullSize ? '100%' : 'fit-content')};
`;

export const DNDButton = styled.div<{ disabled: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 8px;
  width: 110px;
  height: 110px;
  border: 1px dashed #ced5de;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
  text-align: center;
  color: #697180;
  pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};
  opacity: ${(props) => (props.disabled ? '0.6' : '1')};
`;
